// extracted by mini-css-extract-plugin
module.exports = {"message-blocks":"message-blocks__1PDtT"};